import { Circle, Svg } from '@react-pdf/renderer';

export const Bullet = () => {
  return (
    <Svg width='4' height='4' viewBox='0 0 4 4' fill='none'>
      <Circle cx='2' cy='2' r='2' fill='#151515' />
    </Svg>
  );
};
